<template>
  <div id="app_content" class="admin">
    <div class="page-section">
      <ul v-if="msgLoaded" class="row selection">
        <li
          @click="sideSelected = 'contatti'"
          class="col-md-6 text-center pointer"
          :class="sideSelected === 'contatti' ? 'active' : ''"
        >
          <a class="text-center">
            contatti
            <span class="text-lowercase" v-if="contNr > 0"
              >({{ contNr + " nuovi" }})</span
            ></a
          >
        </li>
        <li
          @click="sideSelected = 'suggerimenti'"
          class="col-md-6 text-center pointer"
          :class="sideSelected === 'suggerimenti' ? 'active' : ''"
        >
          <a class="text-center">
            suggerimenti
            <span class="text-lowercase" v-if="suggNr > 0"
              >({{ suggNr + " nuovi" }})</span
            ></a
          >
        </li>
      </ul>

      <!-- CONTATTI     -->

      <ul
        :class="sideSelected === 'contatti' ? 'active' : ''"
        v-if="msgLoaded && sideSelected === 'contatti'"
        id="contatti"
        class="tipo unread row"
      >
        <li
          v-for="(contatto, i) in contatti"
          :key="i"
          class="msg col-md-12 col-12"
          :class="contatto.letto ? 'grey' : ''"
          @click="selectMsg(contatto, contatto.id, 'contatto')"
          v-if="!contatto.letto || showRead"
        >
          <a class="row justify-content-between">
            <span class="col-md-4 col-3 text-truncate"
              ><strong>{{ contatto.nome }}</strong>
              <span>{{ "<" + contatto.email + ">" }}</span></span
            >
            <span class="col-md-6 col-5 text-truncate text-center"
              ><strong>{{ contatto.object }}:</strong
              >{{ " " + contatto.messaggio }}</span
            >
            <span class="col-md-2 col-4 text-right">{{
              getFormat(contatto.created_at)
            }}</span>
          </a>
        </li>
      </ul>

      <!-- SUGGERIMENTI     -->
      <ul
        :class="sideSelected === 'suggerimenti' ? 'active' : ''"
        v-if="msgLoaded && sideSelected === 'suggerimenti'"
        id="suggerimenti"
        class="tipo unread row"
      >
        <li
          v-for="(suggerimento, i) in suggerimenti"
          :key="i"
          class="msg col-md-12 col-12"
          :class="suggerimento.letto ? 'grey' : ''"
          @click="selectMsg(suggerimento, suggerimento.id, 'suggerimento')"
          v-if="!suggerimento.letto || showRead"
        >
          <a class="row justify-content-between">
            <span class="col-md-3 col-2 text-truncate"
              ><strong>{{ suggerimento.referente }}</strong></span
            >
            <span class="col-md-6 col-3 text-truncate text-center">{{
              suggerimento.testo
            }}</span>
            <span class="col-md-1 col-1">
              <i
                v-if="suggerimento.immagine !== null"
                class="fas fa-paperclip"
              ></i>
            </span>
            <span class="col-md-2 col-4 text-right">{{
              getFormat(suggerimento.created_at)
            }}</span>
          </a>
        </li>
      </ul>

      <div class="row mt-3 align-items-baseline">
        <input
          class="mr-3"
          type="checkbox"
          name="showRead"
          id="showRead"
          v-model="showRead"
          value="true"
        />
        <label class="pointer" for="showRead"
          >Mostra i messaggi già letti</label
        >
      </div>

      <!-- BLUR DIV -->
      <div v-show="currentMsg" class="blur" @click.self="selectMsg(0)">
        <div class="messageDiv">
          <message @closeMsg="selectMsg(0)" :message="currentMsg"></message>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import message from "./message";

export default {
  components: { message },

  data: function () {
    return {
      suggerimenti: [],
      contatti: [],
      msgLoaded: false,
      sideSelected: "contatti",
      currentMsg: 0,
      showRead: false,
      suggNr: 0,
      contNr: 0,
    };
  },
  mounted() {
    this.loadMsgs();
  },
  methods: {
    editMsg: function (index, type) {
      axios({
        url: window.location.origin + "/admin/editMsg",
        params: {
          index: index, //
          type: type, //contatti
        },
      })
        .then((res) => {
          // console.log(res.data.success);
        })
        .catch((err) => {
          //console.log(err.response);
        });
    },
    selectMsg: function (msg, index, type) {
      if (!msg) {
        this.currentMsg = 0;
        //console.log(this.currentMsg);
        this.msgLoaded = false;
        this.loadMsgs();
      } else {
        this.currentMsg = msg;
        //console.log(this.currentMsg);
        this.editMsg(index, type);
      }
    },
    getFormat: function (when) {
      return dayjs(when).format("DD MMM");
    },
    loadMsgs: function () {
      this.$store.dispatch("getMessages");
      this.$store.watch(
        (state) => state.msgLoaded,
        (value) => {
          if (value) {
            this.suggerimenti = this.$store.state.suggerimenti;
            this.suggerimenti = this.suggerimenti.sort(
              (b, a) =>
                new Date(a.created_at).getTime() -
                new Date(b.created_at).getTime()
            );
            var newSugg = this.suggerimenti.filter(
              (element) => element.letto === 0
            );
            this.suggNr = newSugg.length;
            this.contatti = this.$store.state.contatti;
            this.contatti = this.contatti.sort(
              (b, a) =>
                new Date(a.created_at).getTime() -
                new Date(b.created_at).getTime()
            );
            var newCont = this.contatti.filter(
              (element) => element.letto === 0
            );
            this.contNr = newCont.length;
            this.msgLoaded = true;
          }
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
a:hover {
  text-decoration: none !important;
}

#app_content {
  ul.selection li {
    padding: 1em;
    text-transform: uppercase;
    background-color: var(--black);
    color: #fff;
    transition: all 0.3s linear;
    &:hover {
      text-decoration: underline;
    }
    &:hover,
    &.active {
      background-color: var(--green);
      color: var(--black);
      width: 100%;
    }
  }

  .tipo {
    &.active {
      border: 5px solid var(--green);
      box-shadow: inset 0 0 10px #000;
      max-height: 500px;
      overflow-y: auto;
    }
    .msg {
      border-bottom: 1px solid #c4c4c6;
      &.grey {
        background-color: #c4c4c6;
        border-bottom: 1px solid #969696;

        &:hover {
          border-right: 1px solid #969696;
          border-left: 1px solid #969696;

          box-shadow: 0px 2px 8px #000;
        }
        strong {
          font-weight: 400;
        }
      }
      &:hover {
        border-right: 1px solid #c4c4c6;
        border-left: 1px solid #c4c4c6;
        box-shadow: 0px 2px 8px #000;
      }
      &.first {
        border-top: 1px solid #c4c4c6;
      }
    }
  }
  .blur {
    width: 100vw;
    height: 100vh;
    position: fixed;
    background-color: rgba(255, 255, 255, 0.7);
    left: 0;
    top: 0;
    z-index: 10;
    backdrop-filter: blur(4px);
    .messageDiv {
      // height: 80vh;
      width: 80vw;
      box-shadow: 0px 2px 8px #c4c4c6;
      border: 5px solid var(--green);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #fff;
    }
  }
}

@media (min-width: 576px) {
  #app_content .tipo.active {
    max-height: unset;
  }
}
</style>